import { render, staticRenderFns } from "./HelpdeskNav.vue?vue&type=template&id=746c7e4c&scoped=true&"
import script from "./HelpdeskNav.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskNav.vue?vue&type=script&lang=ts&"
import style0 from "./HelpdeskNav.vue?vue&type=style&index=0&id=746c7e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c7e4c",
  null
  
)

export default component.exports